module.exports = function loadStyle(src, callback) {
  const head = document.getElementsByTagName('head')[0]
  const link = document.createElement('link')

  link.rel = 'stylesheet'
  link.type = 'text/css'
  link.href = src

  link.onload = callback
  link.onerror = callback

  head.appendChild(link)
}
